// extracted by mini-css-extract-plugin
export default {"donationsCard":"donationsCard__donationsCard--XULlu","donateButton":"donationsCard__donateButton--sWUOA"};